import { render, staticRenderFns } from "./AlertingTeams.vue?vue&type=template&id=31fca71a&scoped=true"
import script from "./AlertingTeams.vue?vue&type=script&lang=js"
export * from "./AlertingTeams.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31fca71a",
  null
  
)

export default component.exports